import { Box, CardMedia, Icon, Skeleton, Typography, useMediaQuery } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'
import { useQuery } from 'react-query'
import { getRecommendedCourse } from 'services/api/modules/upskill'

const RecomendedCourse = () => {
  const isLarge = useMediaQuery((theme) => theme.breakpoints.up('lg'))

  const {
    isLoading: courseIsLoading,
    error: courseIsError,
    data: courseData,
  } = useQuery(
    ['recommendedCourse'],
    async () => {
      const { data } = await getRecommendedCourse()
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  return (
    <Box py={'48px'}>
      <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} mb={'12px'}>
        <Typography variant={isLarge ? 'h4' : 'subtitle1'}>Recommended Courses</Typography>
        <a
          style={{ textDecoration: 'none' }}
          href="https://staging.adnexio.jobs/courses"
          target="_blank"
        >
          <Typography
            color={'alternate.main'}
            sx={{ textDecoration: isLarge ? 'underline' : 'none', cursor: 'pointer' }}
          >
            {isLarge ? 'View All Courses' : 'View All'}{' '}
            {courseIsLoading ? null : `(${courseData?.meta.total})`}
          </Typography>
        </a>
      </Box>
      {courseIsLoading ? (
        <Box display="flex" flexDirection={isLarge ? 'row' : 'column'} gap={'20px'}>
          {Array.from({ length: 3 }, (_, index) => (
            <Box
              key={index}
              padding={'10px'}
              bgcolor="white.main"
              width={isLarge ? 1 / 3 : '100%'}
              sx={{ borderRadius: '4.5px', borderColor: 'gray-line.main' }}
            >
              <Box display="flex" alignItems="center" justifyContent="center">
                <Skeleton variant="rounded" sx={{ height: '120px', width: '100%' }} />
              </Box>
              <Box marginY={'8px'}>
                <Typography variant="h4">
                  <Skeleton variant="text" width={'150px'} />
                </Typography>
                <Typography variant="body2" color="light-gray-text.main">
                  <Skeleton variant="text" width={'150px'} />
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      ) : courseIsError || courseData?.data.length === 0 ? (
        <Box display="flex" gap={'4px'}>
          <AdxEmptyStateV2 icon={<Icon>error</Icon>} title="No available courses found" />
        </Box>
      ) : courseData?.data.length > 0 ? (
        <Box display="flex" flexDirection={isLarge ? 'row' : 'column'} gap={'20px'}>
          {courseData?.data?.map((item, index) => (
            <Box
              key={index}
              display={'flex'}
              flexDirection={'column'}
              justifyContent={'space-between'}
              gap={'16px'}
              padding={'10px'}
              bgcolor="white.main"
              width={isLarge ? 1 / 3 : '100%'}
              sx={{ border: 1, borderRadius: '4.5px', borderColor: 'gray-line.main' }}
            >
              <Box>
                <CardMedia
                  component="img"
                  sx={{
                    height: '177px',
                    width: '100%',
                    objectFit: 'cover',
                    borderRadius: '4.5px',
                  }}
                  src={item.course_logo_url ? item.course_logo_url : '/logo512.png'}
                />
              </Box>
              <Box>
                <Typography variant="h4" mb={'8px'}>
                  {item.course_title}
                </Typography>
                <Typography variant="body1" color="light-gray-text.main">
                  by {item.trainer_name}
                </Typography>
              </Box>
              <a href={item.course_url} target="_blank" rel="noopener noreferrer">
                <AdxButton variant={'contained'} size="small" sx={{ width: '100%' }}>
                  View Details
                </AdxButton>
              </a>
            </Box>
          ))}
        </Box>
      ) : null}
    </Box>
  )
}
export default RecomendedCourse
